import { toast } from 'react-toastify';
import { useWompiModel } from '../../../../modelos/WompiPagos/modeloWompiPagos';
import React, { useState } from 'react';
import { CreditCard, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { isProduction } from '../../../../config/constants';

const WompiPagoWidget = ({ valor, referencia, onSuccess, titulo }) => {
    const [loading, setLoading] = useState(false);
    const { obtenerFirmaIntegridad } = useWompiModel();
    const navigate = useNavigate();
    const publicKey = isProduction ? process.env.REACT_APP_WOMPI_LLAVE_PUBLICA_PRODUCCION : process.env.REACT_APP_WOMPI_LLAVE_PUBLICA_PRUEBA ;

    const manejarPago = async () => {
        try {
            setLoading(true);
            const montoEnCentavos = Math.round(parseFloat(valor) * 100);
            const firma = await obtenerFirmaIntegridad(referencia, montoEnCentavos);

            if (!firma) throw new Error("No se pudo generar la firma");

            const config = {
                currency: 'COP',
                amountInCents: montoEnCentavos,
                reference: referencia,
                publicKey: publicKey, // Cambiar a produccion luego
                signature: { integrity: firma },
            };

            const checkout = new window.WidgetCheckout(config);
            checkout.open((result) => {
                const { transaction } = result;

                if (transaction.status === 'APPROVED') {
                    navigate(`/pago/resultado/${transaction.id}/'pago'`);
                    toast.success("Pago procesado exitosamente");
                    if (onSuccess) onSuccess(transaction);

                } else {

                    navigate(`/pago/resultado/${transaction.id}/'pago'`);
                    toast.warn(`Estado: ${transaction.status}`);
                }
            });
        } catch (error) {
            console.error("Error Wompi:", error);
            toast.error("Error al conectar con Wompi");
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            type="button"
            onClick={manejarPago}
            disabled={loading || !valor || valor <= 0}
            className={`group relative w-full flex flex-col items-center justify-center gap-1 px-4 py-4 rounded-xl font-bold text-white transition-all transform hover:scale-[1.02] active:scale-95 shadow-lg
                ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-br from-[#2b1b81] via-[#3f309b] to-[#7c3aed]'}`}
        >
            <div className="flex items-center gap-2">
                <CreditCard size={20} className="group-hover:animate-pulse" />
                <span className="text-sm uppercase tracking-tight">
                    {loading ? 'Iniciando...' : titulo}
                </span>
            </div>
            
            <div className="flex items-center gap-1.5 mt-1 opacity-80 group-hover:opacity-100 transition-opacity">
                <ShieldCheck size={14} />
                <span className="text-[10px] font-medium uppercase tracking-widest">Pago Seguro vía Wompi</span>
            </div>

            {/* Brillo decorativo */}
            <div className="absolute inset-0 rounded-xl bg-white/10 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity"></div>
        </button>
    );
}

export default WompiPagoWidget;